/* Bee'Zh — interactions du thème : menu mobile, lots, panier AJAX, tiroir, toast. */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(html) {
    var el = $('#Toast');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2400);
  }

  /* ---------- menu mobile ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-burger]');
    if (!b) return;
    var nav = $('#MobileNav');
    var open = nav.classList.toggle('open');
    b.setAttribute('aria-expanded', String(open));
  });

  /* ---------- tiroir panier ---------- */
  var drawer = $('#CartDrawer'), overlay = $('#CartOverlay');
  function openCart() {
    if (!drawer) { window.location.href = T.routes.cart || '/cart'; return; }
    drawer.classList.add('open'); overlay && overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var x = $('[data-close-cart]', drawer); x && x.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open'); overlay && overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-close-cart]')) { closeCart(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- rendu des sections panier ---------- */
  function cartSectionIds() {
    var ids = [];
    $$('[data-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var current = document.getElementById('shopify-section-' + id);
      if (!current) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = sections[id];
      var fresh = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
      if (!fresh) return;
      /* conserve l'état ouvert du tiroir */
      var wasOpen = drawer && drawer.classList.contains('open');
      current.innerHTML = fresh.innerHTML;
      drawer = $('#CartDrawer'); overlay = $('#CartOverlay');
      if (wasOpen && drawer) { drawer.classList.add('open'); overlay && overlay.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
    });
  }
  function updateCount(cart) {
    if (!cart) return;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }
  function refreshCart() {
    var ids = cartSectionIds();
    var p = fetch((T.routes.cart || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(updateCount);
    if (!ids.length) return p;
    return Promise.all([p, fetch((T.routes.root || '/') + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(applySections)]);
  }
  function busy(on) { document.body.classList.toggle('cart-busy', !!on); }

  function addToCart(variantId, qty, button) {
    if (!variantId) return Promise.resolve();
    busy(true);
    if (button) { button.disabled = true; }
    return fetch(T.routes.cartAdd || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty || 1) }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(); })
      .then(function () {
        var n = Number(qty || 1);
        toast('<b>' + n + (n > 1 ? ' pots' : ' pot') + '</b> ' + (n > 1 ? 'ajoutés' : 'ajouté') + ' au panier');
        if (T.cartDrawer) openCart(); else window.location.href = T.routes.cart || '/cart';
      })
      .catch(function (err) { toast((err && err.description) || T.strings.error || 'Erreur'); })
      .then(function () { busy(false); if (button) button.disabled = false; });
  }
  function changeLine(key, qty) {
    busy(true);
    return fetch(T.routes.cartChange || '/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(qty) })
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .catch(function () { toast(T.strings.error || 'Erreur'); })
      .then(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-variant]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-add-variant'), add.getAttribute('data-qty') || 1, add); return; }
    var ch = e.target.closest('[data-change-key]');
    if (ch) { e.preventDefault(); changeLine(ch.getAttribute('data-change-key'), ch.getAttribute('data-qty')); }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-qty-input]');
    if (inp) changeLine(inp.getAttribute('data-qty-input'), inp.value);
  });

  /* formulaire produit en AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]'), q = form.querySelector('[name="quantity"]');
    addToCart(id && id.value, q ? q.value : 1, form.querySelector('[type="submit"]'));
  });

  /* ---------- cartes de lots ---------- */
  function selectCard(card) {
    var group = card.closest('[data-bundle]');
    if (!group) return;
    $$('.card', group).forEach(function (c) { c.setAttribute('aria-pressed', String(c === card)); });
    var sel = group.getAttribute('data-sync-qty');
    if (sel) { var inp = $(sel); if (inp) inp.value = card.getAttribute('data-q'); }
    var lbl = card.getAttribute('data-label');
    if (lbl) $$('[data-mbar-label]').forEach(function (bar) { bar.innerHTML = lbl; });
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-bundle] .card');
    if (!card || e.target.closest('[data-add-variant]')) return;
    selectCard(card);
  });
  document.addEventListener('keydown', function (e) {
    var card = e.target.closest('[data-bundle] .card');
    if (!card) return;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(card); }
  });

  /* ---------- quantité produit ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var inp = $(b.getAttribute('data-qty-step'));
    if (!inp) return;
    var v = Math.max(1, (parseInt(inp.value, 10) || 1) + (b.getAttribute('data-dir') === '-' ? -1 : 1));
    inp.value = v;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- bandeau cookies (API Customer Privacy Shopify) ---------- */
  (function () {
    var b = document.getElementById('CookieBanner');
    if (!b || !window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !Shopify.customerPrivacy) return;
      var cp = Shopify.customerPrivacy;
      try { if (cp.shouldShowBanner()) b.hidden = false; } catch (e) { return; }
      b.addEventListener('click', function (e) {
        var t = e.target.closest('[data-ck]');
        if (!t) return;
        var ok = t.getAttribute('data-ck') === 'accept';
        cp.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok, sale_of_data: ok }, function () { b.hidden = true; });
      });
    });
  })();
})();
